export async function readEventStream(response, onEvent) {
  if (!response.body) {
    throw new Error('Streaming response body unavailable');
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  const emitEvent = async (rawEvent) => {
    const payload = rawEvent
      .split(/\r?\n/)
      .filter((line) => line.startsWith('data: '))
      .map((line) => line.slice(6))
      .join('\n')
      .trim();

    if (!payload) return;

    try {
      await onEvent(JSON.parse(payload));
    } catch {
      // Ignore malformed SSE payloads so one bad event does not kill the stream.
    }
  };

  while (true) {
    const { done, value } = await reader.read();
    buffer += decoder.decode(value || new Uint8Array(), { stream: !done });

    const events = buffer.split(/\r?\n\r?\n/);
    buffer = events.pop() || '';

    for (const rawEvent of events) {
      await emitEvent(rawEvent);
    }

    if (done) break;
  }

  if (buffer.trim()) {
    await emitEvent(buffer);
  }
}
